import React from 'react';
import styled, { keyframes } from 'styled-components';
import * as S from './styles';

const blink = keyframes`
    0% {
      opacity: .2;
    }

    20% {
      opacity: 1;
    }

    100% {
      opacity: .2;
    }
`;

const Loader = styled.div`
    font-size: 20px;
    margin-top: -10px;
    text-shadow: 0 1px 3px #dedede;
    padding: 0 15px;
    > span {
        animation-name: ${blink};
        animation-duration: 1.4s;
        animation-iteration-count: infinite;
        animation-fill-mode: both;

        &:nth-child(2) {
            animation-delay: 0.2s;
        }

        &:nth-child(3) {
            animation-delay: 0.4s;
        }
    }
`;

function LoadInfo() {
    return (
        <S.Dimmer>
            <Loader>
                Checking schedules, please wait<span>.</span>
                <span>.</span>
                <span>.</span>
            </Loader>
        </S.Dimmer>
    );
}

export default LoadInfo;
